export default new (class Menu {
    constructor() {
        this.headerContent = 'header-content';
        this.burgerOpenBtn = 'burger-open';
        this.burgerCloseBtn = 'burger-close';
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {


            //открыть бургер
            document.querySelectorAll(`.${this.burgerOpenBtn}`).forEach((item) => {
                item.addEventListener('click', () => {
                    this.burgerMenuOpen()
                });
            });

            //закрыть бургер
            document.querySelectorAll(`.${this.burgerCloseBtn}`).forEach((item) => {
                item.addEventListener('click', () => {
                    this.burgerMenuClose()
                });
            });

            //закрыть бургер при нажатии на пустоту
            document.querySelector(`header`).addEventListener('click', (e) => {
                if (!e.target.classList.contains(`.${this.headerContent}`) && !e.target.closest(`.${this.headerContent}`) && !e.target.closest(`.${this.burgerOpenBtn}`)) {
                    // console.log(e.target);
                    this.burgerMenuClose()
                }
            });

        });
    }

    /**
     * @description Открыть бургер.
     */
    burgerMenuOpen() {
        document.querySelector(`header`).classList.add('open')
        document.body.classList.add('oc-hidden');
    }

    /**
     * @description Закрыть бургер.
     */
    burgerMenuClose() {
        document.querySelector(`header`).classList.remove('open')
        document.body.classList.remove('oc-hidden');
    }

})()
